export default {
  availability: {
    message: 'Welcome to {store-name}',
    callToAction: 'ENTER',
    instructions: 'Please maintain {distance} apart and follow social distancing guidelines.'
  },
  full: {
    message: 'Sorry we\'re at capacity right now',
    callToAction: 'PLEASE WAIT'
  },
  closed: {
    message: 'We are currently',
    closed: 'closed',
    callToAction: 'Visit us on',
    hours: 'Our opening hours are: ',
    availability: 'Approximately {amount} people can enter the store within the next {time} minutes'
  },
  error: {
    title: 'At capacity.',
    message: 'something went wrong.',
    callToAction: 'Please wait.',
    support:'Contact support.'
  },
  general: {
    capacity: 'Capacity',
    closed: 'Closed',
    days: {
      'sunday': 'Sunday',
      'monday': 'Monday',
      'tuesday': 'Tuesday',
      'wednesday': 'Wednesday',
      'thursday': 'Thursday',
      'friday': 'Friday',
      'saturday': 'Saturday'
    }
  },
};